import React from 'react';
export const useSimpleEvent = (eventInstance, callback) => {
    const [_, set_] = React.useState({});
    React.useEffect(() => {
        // Listen to event and use the instance to remove the listener on destory
        const el = eventInstance.createListener((e) => {
            callback(e);
            set_({});
        });
        return () => eventInstance.removeListener(el);
    }, []);
};
//# sourceMappingURL=useEvent.js.map